import * as React from 'react';
/**
 *
 * Original name: send
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A371
 *
 */
export const SendPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m10.2 23.6 19.37 10.9 11.98 19.168L57.2 6.727 10.2 23.6Zm9.6.8 26.477-9.5-15.618 15.613L19.8 24.4Zm20.645 19.94-6.906-11.05L49.424 17.4l-8.979 26.94Zm-19.859-8.754-10 10 2.829 2.828 10-10-2.829-2.828Zm5.999 6.001-6 6 2.828 2.828 6-6-2.828-2.828Z", fill: "currentColor" })));
